import React from 'react';
import styled from 'styled-components';
import OpenComplete from './OpenComplete';
import OpenError from './OpenError';
import OpenInComplete from './OpenInComplete';

const Open = () => {
    return (
        <WrapperWithStyled>
            <OpenInComplete />
            <OpenComplete />
            <OpenError />
        </WrapperWithStyled>
    );
};
const WrapperWithStyled = styled.div`
    margin-top: 10px;
`

export default Open;